export default {
    searchData:{
        dateRange:[],
        name:"",
        remarks:"",
    },
    pageData:{
        page:1,
        total:0,
        size:20
    },
    showCreateDrawer:false,
    createData:{
        name:"",
        types:[],
        menus:[],
        remarks:""
    },
    // 单位类型
    arrUnitTypes:[],
    tableData:[{}],
    pmsListAll:[]


}



// WEBPACK FOOTER //
// ./src/store/modules/Permission/state.js